import BaseService from './BaseService';

class AllowedWarehousesService extends BaseService {
    getAllowedWarehouses = (filters) => this.post('/warehouse/allowedWarehouse', filters || { });
}
export default new AllowedWarehousesService();